import { Map } from 'immutable';

import { ATTRIBUTE } from '../../../../constants/attributes';

export function tariffCode({ preview }) {
  return {
    payload: Map({
      type: preview.getIn([ATTRIBUTE.SHIPPING, 'operation']),
      value: preview.getIn([ATTRIBUTE.SHIPPING, ATTRIBUTE.TARIFF_CODE]),
    }),
  };
}
